import { combineReducers } from 'redux';

import organization from './organization';

export default combineReducers({
  organization,
});
